import jwtDecode from 'jwt-decode'

import { SET_TOKEN, SET_USER, LOGOUT } from '../constants/actions'

export default (state = false, action) => {
    switch (action.type) {
        case SET_USER:
            const { roles } = action.user
            return {
                ...action.user,
                units: roles.filter(r => !isNaN(r.unit)).map(r => r.unit),
                isGlobalAdmin: roles && roles.filter(r => r.unit === 'global' && r.role === 'admin').length > 0
            }
        case LOGOUT:
            return false
    }
    return state
}



// WEBPACK FOOTER //
// ./reducers/user.js